import { useRef, useState } from 'react';
import { useFormik } from 'formik';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';

import { ModelOfMileage } from '../../database/index';

import api from '../../services/api';
import { useAuth } from 'src/contexts/auth';
import { AxiosResponse } from 'axios';

export const useFormCreateMileages = () => {
	const { userAgencyId } = useAuth();
	const [loading, setLoading] = useState<boolean>(false);
	const [mileageResponse, setMileageResponse] = useState<AxiosResponse | null>(null);
	const [mileageEditedResponse, setMileageEditedResponse] = useState<AxiosResponse | null>(null);
	const history = useHistory();

	const toast: any = useRef();

	const validationSchema = Yup.object().shape({
		DESCRICAO: Yup.string().required('* Campo obrigatório'),
	});

	const saveMileage = async (mileage: ModelOfMileage) => {
		setLoading(true);

		const newMileage: ModelOfMileage = {
			...mileage,
			ORGAO: userAgencyId,
		};

		if (!!mileageResponse) {
			api.put(`mileages/${mileageResponse.data.ID}`, newMileage)
				.then((response) => {
					formik.resetForm();
					setMileageEditedResponse(response);
					setMileageResponse(null);
					setLoading(false);
					toast.current.show({
						severity: 'success',
						summary: 'Edição realizada',
						detail: 'O tipo de quilometragem foi editada com sucesso!',
						life: 5000,
					});
				})
				.catch((err) => {
					console.log(err);
					setLoading(false);
					toast.current.show({
						severity: 'error',
						summary: 'Edição não realizado',
						detail: 'Falha ao realizar operação!',
						life: 5000,
					});
				});
		} else {
			api.post('mileages', newMileage)
				.then((response) => {
					if (window.location.href === '/mileageForm') history.push('/listMileages');
					setLoading(false);
					setMileageResponse(response);
					setMileageEditedResponse(null);
					toast.current.show({
						severity: 'success',
						summary: 'Cadastro realizado',
						detail: 'Operação realizada com sucesso!',
						life: 5000,
					});
				})
				.catch((err) => {
					setLoading(false);
					toast.current.show({
						severity: 'error',
						summary: 'Cadastro não realizado',
						detail: 'Falha ao realizar operação!',
						life: 5000,
					});
				});
		}
	};

	const formik = useFormik<ModelOfMileage>({
		initialValues: {
			ORGAO: '',
			DESCRICAO: '',
		},
		onSubmit: async (values) => await saveMileage(values),
		validationSchema,
	});

	return {
		getMileageFormController: {
			formik,
			loading,
			toast,
			mileageResponse,
			mileageEditedResponse,
		},
		handleMileageFormController: {
			setMileageResponse,
			setMileageEditedResponse,
		},
	};
};
